import React, { useEffect, useState } from 'react';
import { Input, Form, Button, message } from 'antd';
import { DownloadApp } from './Login-children';
import { resetPassword } from '../../../Actions/Authentication';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { ReactComponent as EmailIcon } from '../../../assets/icons/email.svg';
import { ReactComponent as BackArrowIcon } from '../../../assets/icons/backArrow.svg';

import './index.scss';

const ForgetPasswordBox = (props) => {
   const history = useHistory();
   const [isLoading, setIsLoading] = useState(false);

   const formik = useFormik({
      initialValues: {
         username: ''
      },
      validationSchema: Yup.object().shape({
         username: Yup.string()
            .test('email-or-phone', 'อีเมลหรือเบอร์โทรศัพท์ไม่ถูกต้อง', (value) => {
               if (!value) return false;

               // Check if it's a valid email
               const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
               const isEmail = emailRegex.test(value);

               // Check if it's a valid Thai phone number (0XXXXXXXXX)
               const phoneRegex = /^[0][0-9]{9}$/;
               const isPhone = phoneRegex.test(value);
               return isEmail || isPhone;
            })
            .required('กรุณากรอกอีเมลหรือเบอร์โทรศัพท์')
      }),
      onSubmit: (values) => {
         handleSubmit(values);
      }
   });

   useEffect(() => {
      props.form.validateFields();
   }, []);

   const handleSubmit = async (e) => {
      try {
         setIsLoading(true);
         const response = await resetPassword({ userID: e.username });
         if (response.status) {
            message.success(
               <span style={{ fontFamily: 'Prompt', fontSize: '16px' }}>
                  ส่งรหัสผ่านชั่วคราวแล้ว กรุณาตรวจสอบอีเมลหรือข้อความ SMS
               </span>
            );
            handleBack();
         } else {
            if (response.message === 'No User Found')
               message.error(<span style={{ fontFamily: 'Prompt', fontSize: '16px' }}>ไม่พบผู้ใช้งานในระบบ</span>);
         }
      } finally {
         setIsLoading(false);
      }
   };

   const handleBack = () => {
      if (window.innerWidth > 900) props.toForgetPassword(false);
      else history.push('/login');
   };
   return (
      <div className='forget-password-container'>
         <div className='title-container'>
            {props.Page.screensize.width > 900 && <BackArrowIcon onClick={handleBack} />}
            <h1>ลืมรหัสผ่าน?</h1>
         </div>
         <div className='forget-password-container'>
            <form name='forget_password' className='login-form' onSubmit={formik.handleSubmit}>
               <div className='form-group'>
                  <label htmlFor='username'>อีเมล หรือ เบอร์โทรศัพท์</label>
                  <Input
                     name='username'
                     placeholder='กรอกอีเมล หรือ เบอร์โทรศัพท์'
                     value={formik.values.username}
                     className={formik.touched.username && formik.errors.username ? 'error' : ''}
                     onChange={formik.handleChange}
                     onBlur={formik.handleBlur}
                     prefix={<EmailIcon />}
                  />
                  {formik.touched.username && formik.errors.username && (
                     <p className='error'>{formik.errors.username}</p>
                  )}
               </div>
               <div style={{ marginBottom: '16px' }}>
                  <Button type='primary' htmlType='submit' className='login-form-button' disabled={isLoading}>
                     {isLoading ? 'กำลังส่งรหัสผ่านชั่วคราว...' : 'รับรหัสผ่านชั่วคราว'}
                  </Button>
               </div>
            </form>
         </div>
         <DownloadApp />
      </div>
   );
};

const mapStateToProps = (state) => {
   return { Page: state.Page };
};

export default connect(mapStateToProps)(Form.create({ name: 'forget_password' })(ForgetPasswordBox));
